export default {
  isShowLoadData: false,
  personalTypes: [],
  profileList: [],
  userInfo: [],
  accountInfo: [],
  payments: {
    items: []
  },
  price: {},
  isSubscribe: true,
  basket: {
    url: '#',
    price: 0,
    items: []
  },
  delivery: {
    country: [],
    types: [],
    fields: [],
    serviceFields: [],
    items: [],
    pickupItems: []
  },
  isValidateUserInfo: false,
  isValidateAccountInfo: false,
  isValidateDelivery: false,
  globalErrors: [],
  isAuthorized: false,
  moving: {},
  movingAvailabilityByItem: {},
  movingStatus: {
    success: true,
    message: ''
  }
}



// WEBPACK FOOTER //
// ./src/components/store/modules/order/state.js